import { Store } from 'vuex';
import { Context } from 'vuex-smart-module';
import OrganizationsStore from '../../store';
import OrganizationsState from '../../store/state';

export default class OrganizationsSharedState {}
